import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import DateTimeUtil from "../../../../../utils/common/DateTimeUtil";
import {Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import DateRangeFilter from "../../../filter/DateRangeFilter";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import CellCheckboxWithUnable from "../../../сheckbox/CellCheckboxWithUnable";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import ButtonCreate from "../../../button/ButtonCreate";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import DateTimeInput from "../../../filter/DateTimeInput";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";
import IssuanceService from "../../../../../API/orders/prodaction.issueedge/issuance/IssuanceService";
import {useIsAccessGranted} from "../../../../../utils/useIsAccessGranted";


const IssuanceWarehouseMaterialTable = ({
                                            data,
                                            setData,
                                            baseCurrency,
                                            alternativeCurrency,
                                            unableAfterCut,
                                            setUnableAfterCut,
                                            reserve,
                                            afterCut,
                                            tableOptions,
                                            tableOptionsHandle,
                                            handleModalAlert,
                                            getData,
                                            startIssueInitValue,
                                            withFilter, issuingEdges
                                        }) => {

    const canEditQuantity = useIsAccessGranted([]);
    const [start, setStart] = useState(startIssueInitValue);
    const [end, setEnd] = useState(null);
    const [startWrittenOff, setStartWrittenOff] = useState(null);
    const [endWrittenOff, setEndWrittenOff] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [currentEditRow, setCurrentEditRow] = useState(null);
    const [editLoading, setEditLoading] = useState(false);

    const sumAmountBasePrice = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.amountBasePrice, 0),
        [data]
    );

    const sumAmountAlternativePrice = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.amountAlternativePrice, 0),
        [data]
    );

    const sumQuantity = useMemo(
        () => data.reduce((acc, mEU) => acc + mEU.quantity, 0),
        [data]
    );

    const columns = useMemo(() => {

        const baseColumns = [
            {
                id: 'localDateTime',
                header: 'Дата выдачи',
                accessorKey: 'localDateTime',
                minSize: 10,
                maxSize: 10,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? '' : DateTimeUtil.dateTimeToString(value);
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter column={column}/>,
            },

            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 10,
                maxSize: 10,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumQuantity?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'amountBasePrice',
                header: `Факт ${baseCurrency}`,
                accessorKey: 'amountBasePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountBasePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {baseCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'amountAlternativePrice',
                header: `Факт ${alternativeCurrency}`,
                accessorKey: 'amountAlternativePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {alternativeCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'orderNumber',
                header: '№ заказа',
                accessorKey: 'orderNumber',
                minSize: 100,
                maxSize: 150,
            },
            {
                id: 'writtenOff',
                header: 'Дата списания',
                accessorKey: 'writtenOff',
                minSize: 10,
                maxSize: 10,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? '' : DateTimeUtil.dateTimeToString(value);
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                enableHiding: false,
            },
        ];

        if (!reserve && !issuingEdges) {
            baseColumns.splice(0, 0, {
                id: 'articleNumber',
                header: 'Артикул',
                accessorFn: (row) => row.materialWarehouse?.materialPriceUnit.materialOrganizationOption?.articleNumber,
                minSize: 30,
                maxSize: 50,
            });
        }

        if (!reserve && !issuingEdges) {
            baseColumns.splice(1, 0, {
                id: 'name',
                header: 'Наименование',
                accessorFn: (row) => row.materialWarehouse?.materialPriceUnit.materialOrganizationOption?.name,
                minSize: 100,
                maxSize: 150,
            });
        }

        if (afterCut) {
            baseColumns.splice(1, 0, {
                id: 'afterCut',
                header: 'После раскроя',
                accessorKey: 'afterCut',
                size: 8,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: FilterUtil.statusList,
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkStatus(row.getValue(id), filterValue)
                },
                Cell: ({cell, row}) => <CellCheckboxWithUnable
                    id={row.id}
                    unable={unableAfterCut}
                    setUnable={setUnableAfterCut}
                    disabled={true}
                >
                </CellCheckboxWithUnable>,
            });
        }

        return baseColumns;

    }, [data, setData, baseCurrency, alternativeCurrency, unableAfterCut, setUnableAfterCut, reserve, issuingEdges, afterCut, sumQuantity, sumAmountBasePrice, sumAmountAlternativePrice]);

    const handleOpenEditQuantity = (row) => {
        setCurrentEditRow(row);
        setEditModalOpen(true);
    };

    const handleCloseEditQuantity = () => {
        setEditModalOpen(false);
        setCurrentEditRow(null);
    };

    const handleUpdateQuantity = (quantity) => {
        if (currentEditRow == null) {
            return;
        }
        setEditLoading(true);
        IssuanceService.update(currentEditRow.id, quantity)
            .then(function (response) {
                const updated = response?.data;
                setData((prev) => prev.map((el) => {
                    if (el.id !== currentEditRow.id) {
                        return el;
                    }
                    if (updated != null && typeof updated === "object" && updated.id != null) {
                        return {...el, ...updated};
                    }
                    return {...el, quantity: Number(quantity)};
                }));
                handleModalAlert?.("Количество изменено", "success");
                handleCloseEditQuantity();
            })
            .catch(function (error) {
                handleModalAlert?.(error);
            })
            .finally(() => setEditLoading(false));
    };

    const applyFilter = () => {
        const startIssue = start && DateTimeUtil.convertToJavaDateTime(start)
        const finishIssue = end && DateTimeUtil.convertToJavaDateTime(end)
        const startWrittenOffData = startWrittenOff && DateTimeUtil.convertToJavaDateTime(startWrittenOff)
        const finishWrittenOffData = endWrittenOff && DateTimeUtil.convertToJavaDateTime(endWrittenOff)
        getData(startIssue, finishIssue, startWrittenOffData, finishWrittenOffData)
    }

    const cancelFilter = (clear) => {
        getData(clear ? null : DateTimeUtil.convertToJavaDateTime(startIssueInitValue), null, null, null)
        setStart(clear ? null : startIssueInitValue)
        setEnd(null)
        setStartWrittenOff(null)
        setEndWrittenOff(null)
    }
    return (
        <Box>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                {withFilter &&
                    <Box sx={{display: 'flex', justifyContent: "spase-between", alignItems: "flex-end", gap: "9px"}}>
                        <Box>
                            <Typography sx={{fontSize: "16px", fontWeight: 700}}>Выдано от</Typography>
                            <DateTimeInput
                                value={start}
                                setValue={setStart}
                                variant={"outlined"}
                                helperText={"Выдано от"}
                            />
                        </Box>
                        <Box>
                            <Typography sx={{fontSize: "16px", fontWeight: 700}}>Выдано до</Typography>
                            <DateTimeInput
                                variant={"outlined"}
                                value={end}
                                setValue={setEnd}
                                helperText={"Выдано до"}
                            />
                        </Box>
                        <Box>
                            <Typography sx={{fontSize: "16px", fontWeight: 700}}>Списано от</Typography>
                            <DateTimeInput
                                value={startWrittenOff}
                                setValue={setStartWrittenOff}
                                helperText={"Списано от"}
                                variant={"outlined"}
                            />
                        </Box>
                        <Box>
                            <Typography sx={{fontSize: "16px", fontWeight: 700}}>Списано до</Typography>
                            <DateTimeInput
                                value={endWrittenOff}
                                setValue={setEndWrittenOff}
                                helperText={"Списано до"}
                                variant={"outlined"}
                            />
                        </Box>
                        <ButtonCreate
                            text={"Применить фильтр"}
                            width={170}
                            height={43}
                            icon={false}
                            onClick={applyFilter}
                        />
                        <ButtonCreate
                            text={"Отменить фильтр"}
                            width={160}
                            height={43}
                            icon={false}
                            onClick={() => cancelFilter(false)}
                        />
                        <ButtonCreate
                            text={"Очистить фильтр"}
                            width={160}
                            height={43}
                            icon={false}
                            onClick={() => cancelFilter(true)}
                        />
                    </Box>}
            </Box>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='ru'
                localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: `calc(100vh - 460px)`
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                    }}
                    columns={columns}
                    data={data}
                    rowHeight={13}
                    columnSpacing={1}
                    getRowId={(originalRow) => originalRow.id}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    manualPagination={true}
                    state={{showGlobalFilter: true, pagination: tableOptions}}
                    rowCount={tableOptions.totalElements}
                    enableRowActions={canEditQuantity}
                    positionActionsColumn="first"
                    renderRowActionMenuItems={canEditQuantity
                        ? ({closeMenu, row}) => [
                            <MenuItem
                                key="editQuantity"
                                onClick={() => {
                                    handleOpenEditQuantity(row.original);
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                Изменить количество
                            </MenuItem>
                        ]
                        : undefined}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 50},
                        sorting: [
                            {
                                id: 'localDateTime',
                                desc: false,
                            },]
                    }}
                    localization={MRT_Localization_RU}
                    enableToolbarInternalActions={false}
                />
            </LocalizationProvider>
            <ModalEditIssuanceQuantity
                open={editModalOpen}
                initValue={currentEditRow?.quantity}
                loading={editLoading}
                onClose={handleCloseEditQuantity}
                onSubmit={handleUpdateQuantity}
            />
        </Box>
    );
};

const ModalEditIssuanceQuantity = ({open, initValue, onClose, onSubmit, loading}) => {
    const [formState, setFormState] = useState({quantity: initValue ?? ""});
    const [validationState, setValidationState] = useState({quantity: ""});

    useEffect(() => {
        setFormState({quantity: initValue ?? ""});
        setValidationState({quantity: ""});
    }, [open, initValue]);

    const handleSubmit = () => {
        const quantity = formState?.quantity;
        if (quantity === "" || quantity == null) {
            setValidationState({quantity: "пустое поле"});
            return;
        }
        onSubmit(quantity);
    };

    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Изменить количество</DialogTitle>
            <DialogContent style={{paddingBottom: 7}}>
                <FormControl sx={{minWidth: 300}}>
                    <TextFieldValidation
                        type={"number"}
                        name={"quantity"}
                        value={formState?.quantity}
                        label="Количество"
                        setCurrValues={setFormState}
                        validationError={validationState?.quantity}
                        setValidationState={setValidationState}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions sx={{p: "1.25rem"}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd loading={loading} text={"Изменить"} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};


export default IssuanceWarehouseMaterialTable;